import { OrganizationStyle } from "@/api/types/organization"
import { useCallback } from "react"
import { useOrganizationColorsStore } from "@/stores/useOrganizationColorsStore"

export function useSetOrganizationColors() {
  const setColors = useOrganizationColorsStore((state) => state.setColors)

  return useCallback(
    (organizationStyle: OrganizationStyle) => {
      setColors(
        organizationStyle.primaryColor,
        organizationStyle.secondaryColor,
      )
    },
    [setColors],
  )
}
